import { toFiniteFirst } from '@cornerstonejs/utils';
export function isAbsent(value) {
    return value === undefined;
}
export function isEmpty(value) {
    return (value === null ||
        value === '' ||
        (Array.isArray(value) && value.every((item) => hasNoValue(item))));
}
export function hasNoValue(value) {
    return isAbsent(value) || isEmpty(value);
}
export function looseEquals(left, right) {
    if (hasNoValue(left) || hasNoValue(right)) {
        return emptyKind(left) === emptyKind(right);
    }
    const leftArray = Array.isArray(left);
    const rightArray = Array.isArray(right);
    if (leftArray && rightArray) {
        return (left.length === right.length &&
            left.every((element, index) => scalarEquals(element, right[index])));
    }
    if (leftArray) {
        return left.length === 1 && scalarEquals(left[0], right);
    }
    if (rightArray) {
        return right.length === 1 && scalarEquals(left, right[0]);
    }
    return scalarEquals(left, right);
}
function scalarEquals(a, b) {
    if (hasNoValue(a) || hasNoValue(b)) {
        return emptyKind(a) === emptyKind(b);
    }
    if (a === b) {
        return true;
    }
    if (typeof a === 'object' || typeof b === 'object') {
        return false;
    }
    if (typeof a === 'number' || typeof b === 'number') {
        const x = toFiniteFirst(a);
        const y = toFiniteFirst(b);
        if (x !== undefined && y !== undefined) {
            return x === y;
        }
    }
    return String(a) === String(b);
}
function emptyKind(value) {
    if (isAbsent(value)) {
        return 'absent';
    }
    if (value === null) {
        return 'null';
    }
    if (value === '') {
        return 'text';
    }
    return isEmpty(value) ? 'array' : undefined;
}
export function compareFinite(test) {
    return (left, right) => {
        const a = toFiniteFirst(left);
        const b = toFiniteFirst(right);
        return a !== undefined && b !== undefined && test(a, b);
    };
}
export function isTrue(value) {
    return !hasNoValue(value) && Boolean(value);
}
